import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
export function PrescriptionRequired() {
  return <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 shadow-sm" data-id="element-5075" data-mp="2npk988e06ba6">
      <div className="flex items-start mb-4" data-id="element-5076" data-mp="2spewm1ykkiqh">
        <div className="bg-white rounded-full p-2 mr-3" data-id="element-5077" data-mp="2snlqcnrvc0j0">
          <StethoscopeIcon className="w-6 h-6 text-green-600" data-id="element-5078" data-mp="2wr9xj5cl8u3q" />
        </div>
        <div className="flex-1" data-id="element-5079" data-mp="31puyx83ktjtr">
          <h3 className="text-base font-bold text-gray-900 mb-2" data-id="element-5080" data-mp="31qmuiix6bhk1">
            This Product Requires a Prescription
          </h3>
          <p className="text-sm text-gray-700" data-id="element-5081" data-mp="36ndal68zad5g">
            You need a prescription, you can request it through the following
            button
          </p>
        </div>
      </div>
      <button className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-5082" data-mp="3gdg0uyoptd03">
        <StethoscopeIcon className="w-5 h-5" data-id="element-5083" data-mp="3pf60grsr3i8y" />
        Consult a Doctor
      </button>
    </div>;
}